export const crudCard = {
  name: "Nome",
  description: "Descrição"
}